<template>
    <div class="unitdashboard">
        <el-card class="box-card">
            <template #header>
                <div class="logo-header">
                    <span class="ta-left">Deutsches Rotes Kreuz<br>Hurricane Festival 2025<br>Sanitäts- und Rettungsdienst</span>
                    <div>
                        <img src="..//assets/logo-drk.svg" class="logo-image"/>
                        <br>
                        <el-button type="danger" @click="logout">Abmelden</el-button>
                        <br>
                        <router-link v-if="isAdmin" to="/admin/dashboard">
                            <el-button type="warning" style="margin-top: 5px;">Admin-Bereich</el-button>
                        </router-link>
                        <br>
                        <password/>
                    </div>
                </div>
                <div v-if="role">
                    Eigene Einsatzkräfte&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-switch
                        v-model="role_enable"
                        class="ml-2"
                        style="--el-switch-on-color: #67c23a;; --el-switch-off-color: #409eff"
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;Einsatzkräfte BHP
                </div>
                <div v-else-if="showVerpflegung">
                    <router-link to="/verpflegung">
                        <el-button type="primary">Verpflegung</el-button>
                    </router-link>
                </div>
            </template>
            <el-card>
                <template #header>
                    <div class="card-header">
                        <h2>Einsatzkräfteübersicht</h2>
                        <router-link
                            to="/reg"
                            custom
                            v-slot="{ navigate }"
                        >
                            <el-button v-if="!role_enable" type="success" @click="navigate" role="link">Hinzufügen</el-button>
                            <el-button v-if="!role_enable" type="warning" @click="showImportDialog = true">CSV Import</el-button>
                            <export-csv :roleEnable="role_enable"> CSV Export </export-csv>
                        </router-link>
                    </div>
                </template>
                <el-table :data="tableData" stripe style="width: 100%" height="440">
                    <el-table-column label="id" width="1"/>
                    <el-table-column prop="name" label="Name" width="180" sortable/>
                    <el-table-column prop="professional" label="Fachlich" width="120" sortable/>
                    <el-table-column prop="tacticalRD" label="Führung RD" width="130" sortable/>
                    <el-table-column prop="tacticalKatS" label="Führung KatS" width="140" sortable/>
                    <el-table-column prop="food" label="Essen" width="160" sortable/>
                    <el-table-column v-if="role_enable" prop="unit" label="Einheit" width="140" sortable />
                    <el-table-column v-if="role_enable" prop="unit" label="bhp | ktw | zend | sons" width="170">
                        <template #default="{ row }">
                            <el-checkbox v-model="row.bhp" :disabled="true" />
                            <el-checkbox v-model="row.ktw" :disabled="true" />
                            <el-checkbox v-model="row.zen" :disabled="true" />
                            <el-checkbox v-model="row.sonst" :disabled="true" />
                        </template>
                    </el-table-column>
                    <el-table-column v-if="!role_enable" prop="schicht" label="Schicht" width="95" sortable >
                        <template #default="{row}">
                            <el-icon class="circlecheck" v-if="row.schicht === 0">
                                <CircleCheck/>
                            </el-icon>
                            <el-icon class="circleclose" v-else>
                                <el-tooltip
                                    class="box-item"
                                    effect="dark"
                                    content="Einsatzkraft hat eine Doppelschicht oder noch keine"
                                    placement="top-start"
                                >
                                    <CircleClose/>
                                </el-tooltip>

                            </el-icon>
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template #default="scope">
                            <el-button v-if="!role_enable" type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">
                                Bearbeiten
                            </el-button>
                            <el-button v-if="!role_enable" type="primary" size="small" @click="handleDelete(scope.$index, scope.row)">
                                Löschen
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-card class="left">
                <template #header>
                    <div class="card-header">
                        <h2>Übersicht</h2>
                    </div>
                </template>
                <el-row :gutter=12>
                    <el-col :span="8">
                        <el-card class="overview">
                            <template #header>
                                <div class="card-header">
                                    <h3>Fachliche Qualifikation</h3>
                                </div>
                            </template>
                            <el-row :gutter=12>
                                <el-col :span="16">Erste Hilfe:</el-col>
                                <el-col :span="8">{{ eh }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">San:</el-col>
                                <el-col :span="8">{{ san }}</el-col>
                            </el-row>
                            <el-row :gutter=12>
                                <el-col :span="16">Rettungshelfer:</el-col>
                                <el-col :span="8">{{ rh }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">Rettungssanitäter:</el-col>
                                <el-col :span="8">{{ rs }}</el-col>
                            </el-row>
                            <el-row :gutter=12>
                                <el-col :span="16">Rettungsassistent:</el-col>
                                <el-col :span="8">{{ ra }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">Notfallsanitäter:</el-col>
                                <el-col :span="8">{{ nfs }}</el-col>
                            </el-row>
                            <el-row :gutter=12>
                                <el-col :span="16">Arzt:</el-col>
                                <el-col :span="8">{{ arzt }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">Notarzt:</el-col>
                                <el-col :span="8">{{ notarzt }}</el-col>
                            </el-row>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card class="overview">
                            <template #header>
                                <div class="card-header">
                                    <h3>Führung Rettungsdienst</h3>
                                </div>
                            </template>
                            <el-row :gutter=12>
                                <el-col :span="16">Gruppenführer:</el-col>
                                <el-col :span="8">{{ gfRD }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">Zugführer:</el-col>
                                <el-col :span="8">{{ zfRD }}</el-col>
                            </el-row>
                            <el-row :gutter=12>
                                <el-col :span="16">OrgL:</el-col>
                                <el-col :span="8">{{ orgl }}</el-col>
                            </el-row>
                        </el-card>
                        <el-card class="overview">
                            <template #header>
                                <div class="card-header">
                                    <h3>Führung Katastrophenschutz</h3>
                                </div>
                            </template>
                            <el-row :gutter=12>
                                <el-col :span="16">Gruppenführer:</el-col>
                                <el-col :span="8">{{ gfKatS }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">Zugführer:</el-col>
                                <el-col :span="8">{{ zfKatS }}</el-col>
                            </el-row>
                            <el-row :gutter=12>
                                <el-col :span="16">Verbandsführer:</el-col>
                                <el-col :span="8">{{ vf }}</el-col>
                            </el-row>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card class="overview">
                            <template #header>
                                <div class="card-header">
                                    <h3>Essen</h3>
                                </div>
                            </template>
                            <el-row :gutter=12>
                                <el-col :span="16">keine Einschränkung:</el-col>
                                <el-col :span="8">{{ normal }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">glutenfrei:</el-col>
                                <el-col :span="8">{{ gluten }}</el-col>
                            </el-row>
                            <el-row :gutter=12>
                                <el-col :span="16">vegan:</el-col>
                                <el-col :span="8">{{ vegan }}</el-col>
                            </el-row>
                            <el-row :gutter=12 class="odd-row">
                                <el-col :span="16">vegan / glutenfrei:</el-col>
                                <el-col :span="8">{{ vegu }}</el-col>
                            </el-row>
                        </el-card>
                    </el-col>
                </el-row>
            </el-card>
            <el-row :gutter=4>
                <el-col :span="12">
                    <el-card>
                        <template #header>
                            <div class="card-header">
                                <h2>Kräfteübersicht</h2>
                            </div>
                        </template>
                        <el-table :data="tableWorkData" stripe style="width: 100%" :fit="true" class="workingtable">
                            <el-table-column prop="date" label="Datum" width="100"/>
                            <el-table-column prop="day" label="Tag"/>
                            <el-table-column prop="night" label="Nacht"/>
                            <el-table-column prop="concert" label="Konzert"/>
                        </el-table>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card>
                        <template #header>
                            <div class="card-header">
                                <h2>Essensübersicht</h2>
                            </div>
                        </template>
                        <el-table :data="tableMealData" stripe style="width: 100%">
                            <el-table-column prop="date" label="Datum" width="100"/>
                            <el-table-column prop="breakfast" label="Früh"/>
                            <el-table-column prop="lunch" label="Mittag"/>
                            <el-table-column prop="dinner" label="Abend"/>
                            <el-table-column prop="midnightmeal" label="Nacht"/>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
            <el-card>
                <template #header>
                    <div class="card-header">
                        <h2>Car Pass</h2>
                    </div>
                </template>
                <el-table :data="carpass" stripe height="140">
                    <el-table-column label="id" width="1"/>
                    <el-table-column prop="kennzeichen" label="Kennzeichen" width="180" />
                    <el-table-column prop="typ" label="Typ" width="120" />
                    <el-table-column prop="firstname" label="Vornameame" width="160" />
                    <el-table-column prop="name" label="Name" width="460" />
                </el-table>
            </el-card>
        </el-card>

        <!-- CSV Import Dialog -->
        <el-dialog v-model="showImportDialog" title="CSV Import" width="600px">
            <el-upload
                ref="csvUpload"
                :auto-upload="false"
                :on-change="handleFileChange"
                :limit="1"
                accept=".csv"
                drag
            >
                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">
                    CSV-Datei hierher ziehen oder <em>klicken</em>
                </div>
                <template #tip>
                    <div class="el-upload__tip">
                        <strong>Felder:</strong> firstname, name, birthname, birthdate (dd.mm.yyyy), birthtown, birthcountry, email, essen, fachqualifikation, fuehrung_rd, fuehrung_kats, facharzt, notarztqualifikation<br>
                        <a href="/helfer-vorlage.xlsx" download>Vorlage herunterladen</a>
                    </div>
                </template>
            </el-upload>
            <div v-if="csvPreview.length > 0" style="margin-top: 15px;">
                <h4>Vorschau ({{ csvPreview.length }} Einträge<span v-if="csvErrorCount > 0" style="color: #f56c6c;">, {{ csvErrorCount }} fehlerhaft</span>)</h4>
                <el-table :data="csvPreview" stripe style="width: 100%" max-height="300" :row-class-name="tableRowClassName">
                    <el-table-column label="Zeile" width="60">
                        <template #default="{ row }">{{ row._rowNum }}</template>
                    </el-table-column>
                    <el-table-column prop="firstname" label="Vorname" width="100"/>
                    <el-table-column prop="name" label="Name" width="100"/>
                    <el-table-column prop="birthdate" label="Geb.Datum" width="100"/>
                    <el-table-column prop="email" label="E-Mail" width="180"/>
                    <el-table-column label="Fehler">
                        <template #default="{ row }">
                            <span v-if="row._errors.length > 0" style="color: #f56c6c; font-size: 12px;">
                                {{ row._errors.join(', ') }}
                            </span>
                            <span v-else style="color: #67c23a;">OK</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template #footer>
                <el-button @click="clearCsvImport">Abbrechen</el-button>
                <el-button type="success" @click="importCsv" :loading="importing" :disabled="csvPreview.length === 0 || csvErrorCount > 0">
                    {{ csvValidCount }} Helfer importieren
                </el-button>
                <span v-if="csvErrorCount > 0" style="color: #f56c6c; margin-left: 10px; font-size: 12px;">
                    {{ csvErrorCount }} Einträge haben Fehler
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Axios from "axios";
import {ref} from "vue";
import Password from "@/components/password.vue";
import {ElNotification} from "element-plus";
import ExportCsv from "@/components/exportCsv.vue";
import { UploadFilled } from '@element-plus/icons-vue';
import { normalizeProfessional, normalizeLeadership, normalizeEating } from '@/utils/normalize.js';

export default {
    name: "unitDashboard",
    components: { ExportCsv, Password, UploadFilled },
    data() {
        return {
            tableData: [],
            tableWorkData: [],
            tableMealData: [],
            conflicts: [],
            carpass: [],
            normal: 0,
            gluten: 0,
            vegan: 0,
            vegu: 0,
            eh: 0,
            san: 0,
            rh: 0,
            rs: 0,
            ra: 0,
            nfs: 0,
            arzt: 0,
            notarzt: 0,
            gfRD: 0,
            zfRD: 0,
            orgl: 0,
            gfKatS: 0,
            zfKatS: 0,
            vf: 0,
            search: ref(''),
            role_enable: false,
            role: false,
            showImportDialog: false,
            csvPreview: [],
            importing: false
        }
    },

    computed: {
        isAdmin() {
            return this.$store.getters.getRole === 99;
        },
        showVerpflegung() {
            return this.$store.getters.getRole === 2;
        },
        csvErrorCount() {
            return this.csvPreview.filter(r => r._errors && r._errors.length > 0).length;
        },
        csvValidCount() {
            return this.csvPreview.filter(r => !r._errors || r._errors.length === 0).length;
        },
        // filterTableData: this.tableData.filter(
        filteredStories() {
            let filterTableData = this.tableData.filter((Personal) => {
                return Personal.name.toLowerCase().includes(this.search.toLowerCase());
            })
        }
    },

   watch: {
        role_enable() {
            this.loadData();
        }
   },

    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$router.push('/');
        },
        mapTactical(item) {
            switch (normalizeLeadership(item)) {
                case 'gf':
                    return 'Gruppenführer'
                case 'zf':
                    return 'Zugführer'
                case 'vf':
                    return 'Verbandsführer'
                case 'orgl':
                    return 'OrgL'
                default:
                    return '';
            }
        },
        mapProffesinal(item) {
            switch (normalizeProfessional(item)) {
                case 'eh':
                    return 'Erste Hilfe';
                case 'san':
                    return 'SAN';
                case 'rh':
                    return 'Rettungshelfer';
                case 'rs':
                    return 'Rettungssanitäter';
                case 'ra':
                    return 'Rettungsassistent';
                case 'nfs':
                    return 'Notfallsanitäter';
                case 'arzt':
                    return 'Arzt';
                case 'notarzt':
                    return 'Notarzt';
                default:
                    return '';
            }
        },
        mapFood(item) {
            switch (normalizeEating(item)) {
                case 'normal':
                    return 'keine Einschränkung';
                case 'glutenfrei':
                    return 'glutenfrei';
                case 'vegan':
                    return 'vegan';
                case 'vegu':
                    return 'vegan / glutenfrei';
                default:
                    return '';
            }
        },
        async loadPersonal() {
            const me = this;
            try {
                const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/personaldata`, {
                    params: { withRole: this.role_enable }
                });
                me.tableData = [];
                me.notarzt = 0;
                // Konflikte vorab nach personal indexieren – stabiler als find() im Loop
                const conflictByPersonal = {};
                (me.conflicts || []).forEach(c => { conflictByPersonal[c.personal] = c; });
                response.data.data.forEach(item => {
                    const tempConflict = conflictByPersonal[item.id];
                    if (item.notarztQualifikation) {
                        me.notarzt += 1;
                    }
                    // schicht: 0 = OK (genau eine Schicht pro Tag, mind. eine vorhanden)
                    //         1 = Konflikt (mehrere am Tag oder gar keine)
                    //         null = unbekannt (kein worktimes-Datensatz vorhanden) → als Konflikt behandeln
                    let schicht;
                    if (tempConflict === undefined) {
                        schicht = 1;
                    } else {
                        schicht = Number(tempConflict.schicht) === 0 ? 0 : 1;
                    }
                    me.tableData.push({
                        id: item.id,
                        name: item.firstname + ' ' + item.name,
                        vollstaendig: false,
                        professional: me.mapProffesinal(item.professionalValue),
                        tacticalRD: me.mapTactical(item.leadershipRD),
                        tacticalKatS: me.mapTactical(item.leadershipKatS),
                        food: me.mapFood(item.eating),
                        unit: item.unit,
                        schicht: schicht,
                        bhp: item.bhp === 1,
                        ktw: item.ktw === 1,
                        zen: item.zen === 1,
                        sonst: item.sonst === 1,
                    });
                });
            } catch (error) {
                console.log(error);
            }
        },

        async loadPersonalWorktimes() {
            const me = this;
            Axios.get(`${process.env.VUE_APP_API_URL}/api/personalworkdata`, {
                params: {
                    withRole: this.role_enable
                }
            })
                .then(response => {
                    me.tableWorkData = [];
                    response.data.data.forEach(item => {
                        me.tableWorkData.push({
                            date: 'Donnerstag',
                            day: item.doda,
                            night: item.doni,
                            concert: item.doco,
                            ktw: item.dokt
                        });
                        me.tableWorkData.push({
                            date: 'Freitag',
                            day: item.frda,
                            night: item.frni,
                            concert: item.frco,
                            ktw: item.frkt
                        });
                        me.tableWorkData.push({
                            date: 'Samstag',
                            day: item.sada,
                            night: item.sani,
                            concert: item.saco,
                            ktw: item.sakt
                        });
                        me.tableWorkData.push({
                            date: 'Sonntag',
                            day: item.soda,
                            night: item.soni,
                            concert: item.soco,
                            ktw: item.sokt
                        });
                        me.tableWorkData.push({
                            date: 'Montag',
                            day: item.moda,
                            night: item.moni,
                            concert: item.moco,
                            ktw: item.mokt
                        });
                    })
                    console.log('worktime: ', me.tableWorkData);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        async loadPersonalMealTimes() {
            const me = this;
            Axios.get(`${process.env.VUE_APP_API_URL}/api/personalmealdata`, {
                params: {
                    withRole: this.role_enable
                }
            })
                .then(response => {
                    me.tableMealData = [];
                    response.data.data.forEach(item => {
                        me.tableMealData.push({
                            date: 'Donnerstag',
                            breakfast: item.dobr,
                            lunch: item.dolu,
                            dinner: item.dodi,
                            midnightmeal: item.dode
                        });
                        me.tableMealData.push({
                            date: 'Freitag',
                            breakfast: item.frbr,
                            lunch: item.frlu,
                            dinner: item.frdi,
                            midnightmeal: item.frde
                        });
                        me.tableMealData.push({
                            date: 'Samstag',
                            breakfast: item.sabr,
                            lunch: item.salu,
                            dinner: item.sadi,
                            midnightmeal: item.sade
                        });
                        me.tableMealData.push({
                            date: 'Sonntag',
                            breakfast: item.sobr,
                            lunch: item.solu,
                            dinner: item.sodi,
                            midnightmeal: item.sode
                        });
                        me.tableMealData.push({date: 'Montag', breakfast: item.mobr});
                    })
                    console.log(response.data);
                    console.log(me.tableMealData);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        async loadpersonalIncompatibilities() {
            const me = this;
            Axios.get(`${process.env.VUE_APP_API_URL}/api/personalincompatibilities`, {
                params: {
                    withRole: this.role_enable
                }
            })
                .then(response => {
                    me.normal = 0; me.vegan = 0; me.gluten = 0; me.vegu = 0;
                    response.data.data.forEach(item => {
                        const count = Number(item.count) || 0;
                        switch (normalizeEating(item.eating)) {
                            case 'normal':
                                me.normal += count;
                                break;
                            case 'vegan':
                                me.vegan += count;
                                break;
                            case 'glutenfrei':
                                me.gluten += count;
                                break;
                            case 'vegu':
                                me.vegu += count;
                                break;
                        }
                    })
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        async loadpersonalProfessional() {
            const me = this;
            Axios.get(`${process.env.VUE_APP_API_URL}/api/personalprofessional`, {
                params: {
                    withRole: this.role_enable
                }
            })
                .then(response => {
                    me.eh = 0; me.san = 0; me.rh = 0; me.rs = 0; me.ra = 0; me.nfs = 0; me.arzt = 0;
                    response.data.data.forEach(item => {
                        const count = Number(item.count) || 0;
                        switch (normalizeProfessional(item.professionalValue)) {
                            case 'eh':
                                me.eh += count;
                                break;
                            case 'san':
                                me.san += count;
                                break;
                            case 'rh':
                                me.rh += count;
                                break;
                            case 'rs':
                                me.rs += count;
                                break;
                            case 'ra':
                                me.ra += count;
                                break;
                            case 'nfs':
                                me.nfs += count;
                                break;
                            case 'arzt':
                                me.arzt += count;
                                break;
                        }
                    })
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        async loadpersonalLeadership() {
            const me = this;
            Axios.get(`${process.env.VUE_APP_API_URL}/api/personalleadership`, {
                params: {
                    withRole: this.role_enable
                }
            })
                .then(response => {
                    me.gfRD = 0; me.zfRD = 0; me.orgl = 0;
                    me.gfKatS = 0; me.zfKatS = 0; me.vf = 0;
                    response.data.data.forEach(item => {
                        const count = Number(item.count) || 0;
                        const value = normalizeLeadership(item.value);
                        if (item.type === 'rd') {
                            switch (value) {
                                case 'gf': me.gfRD += count; break;
                                case 'zf': me.zfRD += count; break;
                                case 'orgl': me.orgl += count; break;
                            }
                        } else if (item.type === 'kats') {
                            switch (value) {
                                case 'gf': me.gfKatS += count; break;
                                case 'zf': me.zfKatS += count; break;
                                case 'vf': me.vf += count; break;
                            }
                        }
                    })
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        async loadSchichtConflict() {
            const me = this;
            try {
                const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/worktimes/conficts`, {
                    params: { withRole: this.role_enable }
                });
                me.conflicts = response.data.data || [];
            } catch (error) {
                console.log(error);
                me.conflicts = [];
            }
        },

        async loadCarpass() {
            const me = this;
            Axios.get(`${process.env.VUE_APP_API_URL}/api/carpass`, {
                params: {
                    withRole: this.role_enable
                }
            })
                .then(response => {
                    me.carpass = response.data.data;
                    me.carpass.forEach((item, index) => {
                        switch (item.typ) {
                            case "0": me.carpass[index].typ = 'PKW';
                                break;
                            case "1": me.carpass[index].typ = 'MTW';
                                break;
                            case "2": me.carpass[index].typ = 'KTW/RTW';
                                break;
                            case "3": me.carpass[index].typ = 'GW';
                                break;
                            case "4": me.carpass[index].typ = 'LKW';
                                break;
                            case "5": me.carpass[index].typ = 'Sonstiges';
                                break;
                        }
                    });
                })
                .catch(error => {
                    console.log(error);
                })
        },

        handleEdit(index, row) {
            this.$router.push(`/helferedit/${row.id}`);
        },

        handleDelete(index, row) {
            const me = this;
            Axios.delete(`${process.env.VUE_APP_API_URL}/api/personaldata`, {
                params: {
                    unit: me.$store.getters.getUnit,
                    id: row.id
                }
            })
                .then(response => {
                    me.reset();
                    me.loadData();
                    ElNotification({
                        title: 'Erfolg',
                        message: 'Der Helfer wurde gelöscht',
                        type: 'success',
                    });
                })
                .catch(error => {
                    debugger;
                });
        },

        loadData: async function () {
            await this.loadSchichtConflict();
            await this.loadPersonal();
            await this.loadPersonalWorktimes();
            await this.loadPersonalMealTimes();
            await this.loadpersonalIncompatibilities();
            await this.loadpersonalProfessional();
            await this.loadpersonalLeadership();
            await this.loadCarpass();
        },

        reset: function () {
            this.tableData = [];
            this.tableWorkData = [];
            this.tableMealData = [];
            this.normal = 0;
            this.gluten = 0;
            this.vegan = 0;
            this.vegu = 0;
            this.eh = 0;
            this.san = 0;
            this.rh = 0;
            this.rs = 0;
            this.ra = 0;
            this.nfs = 0;
            this.arzt = 0;
            this.notarzt = 0;
            this.gfRD = 0;
            this.zfRD = 0;
            this.orgl = 0;
            this.gfKatS = 0;
            this.zfKatS = 0;
            this.vf = 0;
        },

        handleFileChange(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const text = e.target.result;
                this.parseCsv(text);
            };
            reader.readAsText(file.raw);
        },

        parseCsv(text) {
            const headerMap = {
                'vorname': 'firstname',
                'nachname': 'name',
                'geburtsname': 'birthname',
                'geburtsdatum': 'birthdate',
                'geburtsort': 'birthtown',
                'geburtsland': 'birthcountry',
                'e-mail': 'email',
                'essen': 'essen',
                'fachqualifikation': 'fachqualifikation',
                'fuehrung_rd': 'fuehrung_rd',
                'fuehrung_kats': 'fuehrung_kats',
                'facharzt': 'facharzt',
                'notarztqualifikation': 'notarztqualifikation',
                'do tagschicht': 'do_tag',
                'do nachtschicht': 'do_nacht',
                'do sonstig': 'do_sonstig',
                'fr tagschicht': 'fr_tag',
                'fr nachtschicht': 'fr_nacht',
                'fr konzertschicht': 'fr_konzert',
                'fr sonstig': 'fr_sonstig',
                'sa tagschicht': 'sa_tag',
                'sa nachtschicht': 'sa_nacht',
                'sa konzertschicht': 'sa_konzert',
                'sa sonstig': 'sa_sonstig',
                'so tagschicht': 'so_tag',
                'so nachtschicht': 'so_nacht',
                'so konzertschicht': 'so_konzert',
                'so sonstig': 'so_sonstig',
                'mo tagschicht': 'mo_tag',
                'mo sonstig': 'mo_sonstig',
            };

            const lines = text.split('\n').filter(line => line.trim());
            if (lines.length < 2) {
                ElNotification({
                    title: 'Fehler',
                    message: 'CSV-Datei ist leer oder enthält keine Daten',
                    type: 'error'
                });
                return;
            }

            const rawHeaders = lines[0].split(';').map(h => h.trim().replace(/"/g, ''));
            const headers = rawHeaders.map(h => headerMap[h.toLowerCase()] || h);
            const data = [];
            const requiredFields = ['firstname', 'name', 'birthname', 'birthdate', 'birthtown', 'birthcountry', 'email'];

            for (let i = 1; i < lines.length; i++) {
                const values = lines[i].split(';').map(v => v.trim().replace(/"/g, ''));
                const row = { _errors: [], _rowNum: i };
                headers.forEach((header, index) => {
                    row[header] = values[index] || '';
                });

                // Validierung
                requiredFields.forEach(field => {
                    if (!row[field] || row[field].trim() === '') {
                        row._errors.push(field);
                    }
                });

                // E-Mail Format prüfen
                if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) {
                    if (!row._errors.includes('email')) {
                        row._errors.push('email (ungültiges Format)');
                    }
                }

                // Datum Format prüfen (d.m.yy oder dd.mm.yyyy)
                if (row.birthdate && !/^\d{1,2}\.\d{1,2}\.\d{2,4}$/.test(row.birthdate)) {
                    if (!row._errors.includes('birthdate')) {
                        row._errors.push('birthdate (Format: dd.mm.yyyy)');
                    }
                }

                if (row.name || row.firstname) {
                    data.push(row);
                }
            }

            this.csvPreview = data;
            const errorCount = data.filter(r => r._errors.length > 0).length;

            if (errorCount > 0) {
                ElNotification({
                    title: 'CSV geladen mit Fehlern',
                    message: `${data.length} Einträge gefunden, ${errorCount} mit Fehlern`,
                    type: 'warning'
                });
            } else {
                ElNotification({
                    title: 'CSV geladen',
                    message: `${data.length} Einträge gefunden`,
                    type: 'success'
                });
            }
        },

        clearCsvImport() {
            this.csvPreview = [];
            this.showImportDialog = false;
            if (this.$refs.csvUpload) {
                this.$refs.csvUpload.clearFiles();
            }
        },

        tableRowClassName({ row }) {
            if (row._errors && row._errors.length > 0) {
                return 'error-row';
            }
            return '';
        },

        convertDate(dateStr) {
            if (!dateStr) return dateStr;
            const parts = dateStr.split('.');
            if (parts.length !== 3) return dateStr;
            let [day, month, year] = parts;
            day = day.padStart(2, '0');
            month = month.padStart(2, '0');
            if (year.length === 2) {
                year = parseInt(year) > 50 ? '19' + year : '20' + year;
            }
            return `${year}-${month}-${day}`;
        },

        async importCsv() {
            if (this.csvPreview.length === 0) return;

            this.importing = true;
            try {
                const eatingMap = {
                    'keine einschraenkung': 'normal', 'keine einschränkung': 'normal', 'normal': 'normal',
                    'glutenfrei': 'glutenfrei',
                    'vegan': 'vegan',
                    'vegan / glutenfrei': 'vegu', 'vegan/glutenfrei': 'vegu',
                };
                const professionalMap = {
                    'erste hilfe': 'eh', 'san': 'san',
                    'rettungshelfer': 'rh', 'rettungssanitaeter': 'rs', 'rettungssanitäter': 'rs',
                    'rettungsassistent': 'ra', 'notfallsanitaeter': 'nfs', 'notfallsanitäter': 'nfs',
                    'arzt': 'arzt',
                };
                const leadershipRDMap = {
                    'gruppenfuehrer': 'gf', 'gruppenführer': 'gf',
                    'zugfuehrer': 'zf', 'zugführer': 'zf',
                    'orgl': 'orgl',
                };
                const leadershipKatSMap = {
                    'gruppenfuehrer': 'gf', 'gruppenführer': 'gf',
                    'zugfuehrer': 'zf', 'zugführer': 'zf',
                    'verbandfuehrer': 'vf', 'verbandsfuehrer': 'vf',
                    'verbandführer': 'vf', 'verbandsführer': 'vf',
                };
                const mapLeadership = (val, map) => {
                    if (!val) return null;
                    const lower = val.toLowerCase();
                    if (lower === 'keine') return null;
                    return map[lower] || val;
                };
                const jaToBool = (val) => (val || '').toLowerCase() === 'ja' ? 1 : 0;
                const calculateMealtimes = (row) => {
                    const meals = { dobr: false, dolu: false, dodi: false, dode: false, frbr: false, frlu: false, frdi: false, frde: false, sabr: false, salu: false, sadi: false, sade: false, sobr: false, solu: false, sodi: false, sode: false, mobr: false, molu: false, modi: false, mode: false };
                    // Tagschicht → Frühstück, Mittag, Abend
                    if (row.doda) { meals.dobr = true; meals.dolu = true; meals.dodi = true; }
                    if (row.frda) { meals.frbr = true; meals.frlu = true; meals.frdi = true; }
                    if (row.sada) { meals.sabr = true; meals.salu = true; meals.sadi = true; }
                    if (row.soda) { meals.sobr = true; meals.solu = true; meals.sodi = true; }
                    if (row.moda) { meals.mobr = true; meals.molu = true; meals.modi = true; }
                    // Nachtschicht → Abend, Nacht, Frühstück nächster Tag
                    if (row.doni) { meals.dodi = true; meals.dode = true; meals.frbr = true; }
                    if (row.frni) { meals.frdi = true; meals.frde = true; meals.sabr = true; }
                    if (row.sani) { meals.sadi = true; meals.sade = true; meals.sobr = true; }
                    if (row.soni) { meals.sodi = true; meals.sode = true; meals.mobr = true; }
                    // Konzertschicht → Mittag, Abend, Nacht
                    if (row.frco) { meals.frlu = true; meals.frdi = true; meals.frde = true; }
                    if (row.saco) { meals.salu = true; meals.sadi = true; meals.sade = true; }
                    if (row.soco) { meals.solu = true; meals.sodi = true; meals.sode = true; }
                    return meals;
                };
                const csvData = this.csvPreview.map(row => {
                    const mapped = {
                        ...row,
                        birthdate: this.convertDate(row.birthdate),
                        eating: eatingMap[(row.essen || '').toLowerCase()] || row.essen || '',
                        professionalValue: professionalMap[(row.fachqualifikation || '').toLowerCase()] || row.fachqualifikation || '',
                        leadershipRD: mapLeadership(row.fuehrung_rd, leadershipRDMap),
                        leadershipKatS: mapLeadership(row.fuehrung_kats, leadershipKatSMap),
                        facharzt: jaToBool(row.facharzt),
                        notarztQualifikation: jaToBool(row.notarztqualifikation),
                        doda: jaToBool(row.do_tag),
                        doni: jaToBool(row.do_nacht),
                        dokt: row.do_sonstig ? (jaToBool(row.do_sonstig) ? 1 : 2) : 2,
                        frda: jaToBool(row.fr_tag),
                        frni: jaToBool(row.fr_nacht),
                        frco: jaToBool(row.fr_konzert),
                        frkt: row.fr_sonstig ? (jaToBool(row.fr_sonstig) ? 1 : 2) : 2,
                        sada: jaToBool(row.sa_tag),
                        sani: jaToBool(row.sa_nacht),
                        saco: jaToBool(row.sa_konzert),
                        sakt: row.sa_sonstig ? (jaToBool(row.sa_sonstig) ? 1 : 2) : 2,
                        soda: jaToBool(row.so_tag),
                        soni: jaToBool(row.so_nacht),
                        soco: jaToBool(row.so_konzert),
                        sokt: row.so_sonstig ? (jaToBool(row.so_sonstig) ? 1 : 2) : 2,
                        moda: jaToBool(row.mo_tag),
                        mokt: row.mo_sonstig ? (jaToBool(row.mo_sonstig) ? 1 : 2) : 2,
                    };
                    return { ...mapped, ...calculateMealtimes(mapped) };
                });
                const response = await Axios.post(`${process.env.VUE_APP_API_URL}/api/import-csv`, {
                    csv_data: csvData
                });

                ElNotification({
                    title: 'Import erfolgreich',
                    message: response.data.message,
                    type: 'success'
                });

                if (response.data.data.errors && response.data.data.errors.length > 0) {
                    ElNotification({
                        title: 'Warnungen',
                        message: response.data.data.errors.join(', '),
                        type: 'warning',
                        duration: 10000
                    });
                }

                this.clearCsvImport();
                this.reset();
                this.loadData();
            } catch (error) {
                ElNotification({
                    title: 'Fehler',
                    message: error.response?.data?.message || 'Import fehlgeschlagen',
                    type: 'error'
                });
            } finally {
                this.importing = false;
            }
        }
    },
    async created() {
        if (!this.$store.getters.isLoggedIn) {
            this.$router.push('/');
        }
        this.role = this.$store.getters.getRole === 1;
        await this.loadData();
    },

}
</script>

<style scoped>
.box-card {
    max-width: 1100px;
    flex: auto;

}

table.el-table__body {
    width: 100% !important;
}

.workingtable table {
    width: 100%;
}

.unitdashboard {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.left {
    text-align: left;
}

.left h3 {
    margin-bottom: 0px;
}

.odd-row {
    background-color: rgb(250, 250, 250);
    border-bottom-color: rgb(128, 128, 128);
    border-top-color: rgb(128, 128, 128);
    border-collapse: separate;
}

.overview {
    color: rgb(96, 98, 102);
}

.overview h3 {
    color: black;
}

.logo-image {
    width: 200px;
    display: flex;
}

.logo-header {
    justify-content: space-between;
    display: flex;
}

.ta-left {
    text-align: left;
}

.hover-tooltip:hover::before {
    content: "Funktionalität wird noch erstellt";
    position: absolute;
    top: 20px;
    left: 0;
    padding: 5px;
    background-color: #333;
    color: #fff;
    font-size: 14px;
    border-radius: 5px;
    z-index: 9999;
}

.circlecheck {
    color: green;
}

.circleclose {
    color: red;
}

.el-table .el-table__header th,
.el-table .el-table__body td {
    text-align: left; /* Links ausrichten */
}

:deep(.el-table .error-row) {
    background-color: #fef0f0 !important;
}

:deep(.el-table .error-row:hover > td) {
    background-color: #fde2e2 !important;
}
</style>
